import Bold from './bold.js';
let Italic = /*#__PURE__*/(() => {
  class Italic extends Bold {
    static blotName = 'italic';
    static tagName = ['EM', 'I'];
  }
  return Italic;
})();
export default Italic;
